import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { getTreatmentPlanAppointmentCounts } from 'api/home';
import { getRecheckAppointments } from 'api/eligibility';
import { TreatmentPlanAppointmentCountsVo } from 'types/home';
import { TRecheckAppointmentVo } from 'types/insuranceEligibility';
import TodoListModal, { TTodoTab } from './TodoListModal';
import s from './s.module.less';

const TodoList: React.FC = () => {
    const [todoData, setTodoData] = useState<TreatmentPlanAppointmentCountsVo | null>(null);
    // Insurance to re-check（§2.7）：患者传了新卡、等 provider 复查的未来预约
    const [recheckItems, setRecheckItems] = useState<TRecheckAppointmentVo[]>([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [initialTab, setInitialTab] = useState<TTodoTab>('inProgress');

    // 获取待办数据（visit notes 计数 + recheck 列表并行）
    const fetchTodoCount = async () => {
        try {
            const [result, recheck] = await Promise.all([getTreatmentPlanAppointmentCounts(), getRecheckAppointments()]);
            if (!result.error && result.data?.data) {
                setTodoData(result.data.data);
            }
            setRecheckItems(recheck);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to fetch todo count:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTodoCount();
    }, []);

    const openModal = (tab: TTodoTab) => {
        setInitialTab(tab);
        setModalOpen(true);
    };

    // visit notes 待办数：IN_PROGRESS + OVERDUE
    const notesCount = todoData ? todoData.inProgressCount + todoData.overdueCount : 0;
    const recheckCount = recheckItems.length;
    const totalCount = notesCount + recheckCount;

    // 如果没有数据或总数为0，不显示组件
    if (loading || totalCount === 0) {
        return null;
    }

    return (
        <div className={s.wrapper}>
            <h3 className={s.title}>To-do list ({totalCount})</h3>
            <div className={s.card}>
                <div className={s.content}>
                    {/* Insurance to re-check 行恒在 Pending visit notes 之上（设计拍板） */}
                    {recheckCount > 0 && (
                        <div className={s.todoItem}>
                            <div className={s.todoLabel}>Insurance to re-check ({recheckCount})</div>
                            <Button className={s.resumeButton} onClick={() => openModal('recheck')}>
                                Check
                            </Button>
                        </div>
                    )}
                    {notesCount > 0 && (
                        <div className={s.todoItem}>
                            <div className={s.todoLabel}>Pending visit notes ({notesCount})</div>
                            <Button className={s.resumeButton} onClick={() => openModal('inProgress')}>
                                Resume
                            </Button>
                        </div>
                    )}
                    <div
                        className={s.viewAll}
                        onClick={() => openModal(recheckCount > 0 ? 'recheck' : 'inProgress')}
                    >
                        <span className={s.viewAllText}>View all</span>
                        <div className={s.arrowIcon}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289L17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L13.7071 14.7071C13.3166 15.0976 12.6834 15.0976 12.2929 14.7071C11.9024 14.3166 11.9024 13.6834 12.2929 13.2929L14.5858 11H3C2.44772 11 2 10.5523 2 10C2 9.44772 2.44772 9 3 9H14.5858L12.2929 6.70711C11.9024 6.31658 11.9024 5.68342 12.2929 5.29289Z"
                                    fill="#0E62F4"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <TodoListModal
                open={modalOpen}
                initialTab={initialTab}
                onClose={() => setModalOpen(false)}
                onDataUpdate={fetchTodoCount}
            />
        </div>
    );
};

export default TodoList;
